import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { Card, Input, Button, message } from 'antd';
import { makeSchoolRequest, clearMessage } from '../../../_actions/user_actions';

function AddSchoolPage(props) {
  const dispatch = useDispatch();

  const [formState, setFormState] = useState({
    school: '',
    firstName: '',
    lastName: '',
    city: '',
    zip: '',
    email: '',
  });

  useEffect(() => {
    if (!props.user.message) return;
    if (props.user.message.includes("Success")) {
      message.success(props.user.message);
      props.history.push("/sysadmin/schools");
    }
    else {
      message.error(props.user.message);
    }
    dispatch(clearMessage());
  }, [props.user.message, dispatch, props.history]);

  const handleChange = (field) => (e) => {
    setFormState({ ...formState, [field]: e.target.value });
  };

  const handleSubmit = () => {
    const { school, firstName, lastName, city, zip, email } = formState;

    if (!school || !firstName || !lastName || !city || !zip || !email) {
      message.error("All fields are required");
      return;
    }

    let dataToSubmit = {
        school, 
        firstName, 
        lastName, 
        city, 
        zip: parseInt(zip), 
        email
    }

    dispatch(makeSchoolRequest(dataToSubmit));
  };

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', padding: 16 }}>
      <Card title="Create a New School">
        <Input 
          placeholder="School Name" 
          value={formState.school} 
          onChange={handleChange('school')} 
          style={{ marginBottom: 12 }} 
        />
        <Input 
          placeholder="First Name" 
          value={formState.firstName} 
          onChange={handleChange('firstName')} 
          style={{ marginBottom: 12 }} 
        />
        <Input 
          placeholder="Last Name" 
          value={formState.lastName} 
          onChange={handleChange('lastName')} 
          style={{ marginBottom: 12 }} 
        />
        <Input 
          placeholder="City" 
          value={formState.city} 
          onChange={handleChange('city')} 
          style={{ marginBottom: 12 }} 
        />
        <Input 
          placeholder="Zip Code" 
          type="number"
          value={formState.zip} 
          onChange={handleChange('zip')} 
          style={{ marginBottom: 12 }} 
        />
        <Input 
          placeholder="Email Address" 
          value={formState.email} 
          onChange={handleChange('email')} 
          style={{ marginBottom: 16 }} 
        />
        <Button type="primary" block onClick={handleSubmit}>
          Create School
        </Button>
      </Card>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default withRouter(connect(mapStateToProps)(AddSchoolPage));
